var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.99998 4.66667H13V11.336C13 11.7027 12.7033 12 12.338 12H1.66198C1.5749 11.9999 1.48869 11.9827 1.40828 11.9492C1.32788 11.9158 1.25484 11.8669 1.19336 11.8052C1.13188 11.7435 1.08316 11.6704 1.04998 11.5898C1.01679 11.5093 0.999804 11.4231 0.99998 11.336V4.66667ZM4.99998 6V7.33333H8.99998V6H4.99998ZM0.333313 0.666667C0.333313 0.298667 0.636646 0 0.994646 0H13.0053C13.3706 0 13.6666 0.296 13.6666 0.666667V3.33333H0.333313V0.666667Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.19bdc4a3600293a13d565df1c1d537f9.svg";
export { ForwardRef as ReactComponent };